import * as Scrivito from "scrivito";
import metadataAttributes from "../_metadataAttributes";
import defaultPageAttributes from "../_defaultPageAttributes";

const NewsPage = Scrivito.provideObjClass("NewsPage", {
  onlyInside: ["NewsOverviewPage", "GlobalNewsOverviewPage"],
  attributes: {
    title: "string",
    author: "string",
    description: "string",
    shortDescription: "string",
    publishFromDate: "date",
    publishUntilDate: "date",
    image: ["reference", { only: "Image" }],
    video: "string",
    tags: "stringlist",
    body: "widgetlist",
    customizableCategories: "stringlist",
    migrated: "boolean",
    displayOnThisPage: ["referencelist", { only: "NewsOverviewPage" }],
    showInGlobalNews: "boolean",
    ...metadataAttributes,
    ...defaultPageAttributes,
  },
  extractTextAttributes: [
    "title",
    "author",
    "description",
    "shortDescription",
    "video",
    "body",
  ],
});

export default NewsPage;
